import {Service} from "./service";

export class Context {
  public service: Service = new Service();
}
